import React, { useEffect, useState } from 'react';

import './qa-qc-sample-test.css';
import { Form, Input, Select, Card, Row, Col, Upload, message, UploadProps, DatePicker, FormInstance, InputNumber, Button } from 'antd';
import { Link, Redirect, useHistory } from 'react-router-dom';
import moment from 'moment';
import { LotCodeDropDown, OperationIdRequest, OperationRequest, OperationsDropDown, QaQcDropDown, WorkStationCategoryReq, WorkStationsDropDown } from '@gtpl/shared-models/production-management';
import { QaQcTestResultEnum, RejectionReasonsEnum, ShiftsEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { LotCodeOpsService, OperationService, QaQcOperationsService, QaQcSampleTestService, WorkstationService } from '@gtpl/shared-services/production';
import TextArea from 'antd/lib/input/TextArea';
const { Option } = Select;
import { ItemsDetails, SaleOrderDropDownDto } from '@gtpl/shared-models/sale-management';
import { saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';

/* eslint-disable-next-line */
export interface QaQcSampleTestProps { }

export function QaQcSampleTest(
  props: QaQcSampleTestProps
) {
  let history = useHistory();
  const [qaQcSampleTestForm] = Form.useForm();
  const [operations, setOperations] = useState<OperationsDropDown[]>([]);
  const [lotNumbers, setLotNumbers] = useState<LotCodeDropDown[]>([]);
  const [testsData, setTestsData] = useState<QaQcDropDown[]>([]);
  const [soData, setSoData] = useState<SaleOrderDropDownDto[]>([]);
  const [soItemData, setSoItemData] = useState<ItemsDetails[]>([]);
  const [workStations, setWorkStations] = useState<WorkStationsDropDown[]>([]);
  const [disable, setDisable] = useState<boolean>(false)
  const lotCodeService = new LotCodeOpsService();
  const operationService = new OperationService();
  const workstationService = new WorkstationService();
  const qaQcService = new QaQcOperationsService();
  const qaQcSampleTestService = new QaQcSampleTestService();
  const saleOrderService = new SaleOrderService();

  useEffect(() => {
    qaQcSampleTestForm.setFieldsValue({ noOfSamples:1,quantityTested:30 })
    getAllLotNumbers();
    getAllOperations();
    getAllSoDropDown();
  }, [])

  const getAllLotNumbers = () => {
    const plant = Number(localStorage.getItem('unit_id'))
    const lotNoReq = new UnitRequest(plant);

    lotCodeService.getAllLotNumbers(lotNoReq).then((res) => {
      if (res.status) {
        setLotNumbers(res.data);
      } else {
        setLotNumbers([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setLotNumbers([]);
    });

  }

  const getAllOperations = () => {
    operationService.getAllOperationsDropDown().then(res => {
      if (res.status) {
        setOperations(res.data);
      } else {
        setOperations([]);
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setOperations([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const getAllSoDropDown = () => {
    saleOrderService.getSaleOrdersDropDownList().then((res) => {
      if (res.status) {
        setSoData(res.data);
      } else {
        if (res.intlCode) {
          setSoData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    })
      .catch((err) => {
        setSoData([]);
        AlertMessages.getErrorMessage(err.message);
      });
  };

  const handleSoChange = (value) => {
    console.log('selected SO value:' + value)
    qaQcSampleTestForm.setFieldsValue({
      saleOrderItemId: ''
    })
    getAllSoItemsDropDown(value);
  }

  const getAllSoItemsDropDown = (selectedSoData) => {
    const soREq: saleOrder = {
      saleOrderId: selectedSoData
    }
    saleOrderService.getSaleOrderItemsForSo(soREq).then((res) => {
      if (res.status) {
        setSoItemData(res.data.itemsDetails);
        // AlertMessages.getSuccessMessage('Sale Orders retrived Successfully');
      } else {
        if (res.intlCode) {
          setSoItemData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setSoItemData([]);
      }
    })
      .catch((err) => {
        setSoItemData(null);
        AlertMessages.getErrorMessage(err.message);
      });
  };

  const getWorkStations = () => {
    qaQcSampleTestForm.setFieldsValue({
      workstation: ''
    })
    const operationsId = qaQcSampleTestForm.getFieldValue('operation');
    let workstationCategory;
    operations.map((operation) => {
      if (operation.operationId == operationsId) {
        workstationCategory = operation.workstationCategoryId;
      }
    })
    const catReq = new WorkStationCategoryReq();
    catReq.workstationCategory = workstationCategory;
    catReq.unitId = Number(localStorage.getItem('unit_id'));
    workstationService.getWorkStationsForCategory(catReq).then((res) => {
      if (res.status) {
        setWorkStations(res.data);
      } else {
        setWorkStations([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setWorkStations([]);
    });
  }


  const getAllQcQcActiveTestsForOperation = (operationId) => {
    if (operationId) {
      getWorkStations();
      const opRequest = new OperationIdRequest(operationId)
      qaQcService.getAllQcQcDropDownForOperation(opRequest).then(res => {
        if (res.status) {
          setTestsData(res.data);
        } else {
          setTestsData([]);
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        setTestsData([]);
        AlertMessages.getErrorMessage(err.message);
      })
    }
  }

  const onFinish = () => {
    setDisable(true)
    qaQcSampleTestForm.validateFields().then(formDetails => {
      formDetails.plantId = Number(localStorage.getItem('unit_id'));
      qaQcSampleTestService.CreateQaQcSampleData(formDetails).then((res) => {
        setDisable(false)
        if (res.status) {
          AlertMessages.getSuccessMessage(res.internalMessage);
          history.push('/qa-qc-sample-test-grid')
        } else {

        }
      }).catch((err) => {
        setDisable(false)
        AlertMessages.getErrorMessage(err.message);

      });
    })
  }

  const onReset = () => {
    qaQcSampleTestForm.resetFields();
  };


  return (
    <Card >
      <Form layout={'vertical'} form={qaQcSampleTestForm} name="control-hooks">
        <Card title={<span style={{ color: 'white' }}>Lot Details</span>}
          style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}  extra={<Link to='/qa-qc-sample-test-grid' ><Button className='panel_button' > View </Button></Link>}>
          <Row gutter={24}>
            <Form.Item name="testSampleId" >
              <Input hidden />
            </Form.Item>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>

              <Form.Item name="lotNumber" label="Lot No" rules={[{ required: true, message: 'Missing Lot No' }]}>
                <Select
                  placeholder="Select Lot No"
                  allowClear
                >
                  <Option key={0} value={null}>Select Lot</Option>
                  {lotNumbers.map((lot) => {
                    return <Option key={lot.lotCodeOpsId} value={lot.lotNumber}>{lot.lotNumber}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>

              <Form.Item name="saleOrderId" label="SO Number" rules={[{ required: true, message: 'Missing SO Number' }]}>
                <Select
                  placeholder="Select SO Number"
                  allowClear
                  onChange={handleSoChange}
                >
                  {soData.map((dropData) => {
                    return (
                      <Option
                        name="saleOrderId"
                        key={dropData.saleOrderId}
                        value={dropData.saleOrderId}
                      >
                        {dropData.saleOrderNumber}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>

              <Form.Item name="saleOrderItemId" label="SO Item" rules={[{ required: true, message: 'Missing SO Number' }]}>
                <Select
                  placeholder="Select SO Item"
                  allowClear
                >
                  {soItemData.map((dropData) => {
                    return (
                      <Option
                        name="saleOrderItemId"
                        key={dropData.saleOrderItemId}
                        value={dropData.saleOrderItemId}
                      >
                        {dropData.item}
                      </Option>
                    );
                  })}

                </Select>
              </Form.Item>
            </Col>


            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }} >
              <Form.Item name="shift" label="Shift" rules={[{ required: true, message: 'Missing Shift' }]} >
                <Select
                  placeholder="Select Shift"
                  allowClear
                >
                  <Option key={0} value={null}>Select Shift</Option>
                  <Option key={1} selected value={ShiftsEnum.General}>{ShiftsEnum.General}</Option>
                  <Option key={2} value={ShiftsEnum.Shift_A}>{ShiftsEnum.Shift_A}</Option>
                  <Option key={3} value={ShiftsEnum.Shift_B}>{ShiftsEnum.Shift_B}</Option>
                  <Option key={4} value={ShiftsEnum.Shift_C}>{ShiftsEnum.Shift_C}</Option>
                </Select>
              </Form.Item>

            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>

              <Form.Item
                name="operation"
                label="Operation"
                rules={[
                  {
                    required: true, message: 'Operation Name is required'

                  },

                ]}>
                <Select
                  showSearch
                  placeholder="Select Operation Category"
                  onChange={getAllQcQcActiveTestsForOperation}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  <Option key={0} value={null}>Select Operations</Option>
                  {operations.map((operation) => {
                    return <Option key={operation.operationId} value={operation.operationId}>{operation.operationName}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>

              <Form.Item name="workstation" label="Workstation" rules={[{ required: true, message: 'Missing Workstation' }]}>
                <Select
                  placeholder="Select Workstation"
                  allowClear
                >
                  {workStations.map(dropData => {
                    return <Option key={dropData.workstationId} value={dropData.workstationId}>{dropData.workstation}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <br />
        <br />
        <Card title={<span style={{ color: 'white' }}>QC Details</span>}
          style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}>
          <Row gutter={24}>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>

              <Form.Item name="qaQcTestId" label="Test" rules={[{ required: true, message: 'Missing Test' }]}>
                <Select
                  placeholder="Select Test"
                  allowClear
                >
                  <Option key={0} value={null}>Select Tests</Option>
                  {testsData.map((test) => {
                    return <Option key={test.qaQcTestId} value={test.qaQcTestId}>{test.testName}</Option>
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>

              <Form.Item name="noOfSamples" label="No. Of. Samples" rules={[{ required: true, message: 'Missing No. Of. Samples' }]}>
                <InputNumber style={{ width: '100%' }} min={0} />
              </Form.Item>

            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>

              <Form.Item name="count" label="Tested Count" rules={[{ required: true, message: 'Missing Count' }]}>
                <InputNumber style={{ width: '100%' }} min={0} />
              </Form.Item>

            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>

              <Form.Item name="quantityTested" label="Quantity Tested" rules={[{ required: true, message: 'Missing Quantity Tested' }]}>
                <InputNumber style={{ width: '100%' }} min={0} />
              </Form.Item>

            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} >

              <Form.Item name="rejectedQuantity" label="Rejected Quantity" rules={[{ required: true, message: 'Missing Rejection Quantity' }]}>
                <InputNumber style={{ width: '100%' }} min={0} />
              </Form.Item>

            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }} >
              <Form.Item name="rejectionReason" label="Rejection Reason" rules={[{ required: true, message: 'Missing Rejection Reason' }]}>
                <Select
                  placeholder="Select Rejection Reason"
                  allowClear
                >
                  <Option key={0} value={null}>Select Rejection Reason</Option>
                  <Option key={1} selected value={RejectionReasonsEnum.BLACK_DOTES}>{RejectionReasonsEnum.BLACK_DOTES}</Option>

                </Select>
              </Form.Item>

            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }} >
              <Form.Item name="testResult" label="Test Result" rules={[{ required: true, message: 'Missing Test Result' }]} >
                <Select
                  placeholder="Select Test Result"
                  allowClear
                >
                  <Option key={0} value={null}>Select Test Result</Option>
                  <Option key={1} selected value={QaQcTestResultEnum.TEST_RESULT}>{QaQcTestResultEnum.TEST_RESULT}</Option>

                </Select>
              </Form.Item>

            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} >
              <Form.Item name="remarks" label="Remarks" rules={[{ required: true, message: 'Missing Remarks' }]} >
                <TextArea rows={4}></TextArea>
              </Form.Item>

            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }} style={{ paddingTop: '92px' }}>
                <Button type='primary'disabled={disable} onClick={onFinish}>
                  Submit
                </Button>
                <Button htmlType="button" style={{ margin: '0 14px', color:'white', backgroundColor:'red' }} onClick={onReset}>
                  Cancel
                </Button>
            </Col>
          </Row>
        </Card>
      </Form>

    </Card>
  );
}
export default QaQcSampleTest;
